<template>
  <div class="attachmentCnt">
    <h4 class="aTitle">Attachment</h4>
    <a :href="att.uri" :download="att.filename" class="attachmentItem"
      v-for="(att, i) in attachments" :key="`att${i}`"
      target="_blank">
      <div class="attachmentIcon" v-if="att.type === 'image'"
        :style="{'background-image': `url(${att.imageTh})`}"
        :class="att.type"></div>
      <div class="attachmentIcon" v-else-if="att.type === 'video'"
        :style="{'background-image': `url(${att.mainThumb})`}"
        :class="att.type"></div>
      <div class="attachmentIcon" v-else :class="att.type"></div>
      <h4>{{att.name}}</h4>
      <div class="aIcon download"></div>
    </a>
  </div>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'attachments',
  components: {},
  props: ['attachments'],
  data() {
    return {
      show: false,
      next: null,
      detail: null,
      sessionId: '',
    };
  },
  methods: {
    recordDownload() {},
  },
};
</script>

<style scoped lang="scss">
.attachmentCnt{
  margin: 30px 0 0;
  padding: 20px 0 0;
  border-top: #999 1px solid;
  .aTitle{
    font-size: 18px;
    margin: 0 0 6px 7px;
  }
  .attachmentItem{
    position: relative;
    padding: 6px 6px;
    padding-right: 120px;
    background-color: #eee;
    border-radius: 5px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    color: #444;
    transition: all .3s ease;
    cursor: pointer;
    &:hover{
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      background-color: #fff;
    }
    .attachmentIcon{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px; height: 26px;
      border-radius: 5px;
      background-color: #d9d6e4;
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/attachment.png);
      font-size: 13px;
      color: #fff;
      font-weight: 600;
      text-transform: uppercase;
      margin-right: 10px;
      &.pdf{
        background-color: #e21717;
        background-image: url(../assets/pdf-icon-white.png);
      }
      &.audio{
        background-image: url(../assets/musical-note-blue.svg);
      }
      &.image{
        background-size: cover;
      }
      &.video{
        background-size: cover;
      }
    }
    .aIcon{
      position: absolute;
      width: 30px; height: 30px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 12px auto;
      background-image: url(../assets/close.png);
      border-radius: 50%;
      top: 50%; right: 10px;
      margin-top: -15px;
      transition: background-color .3s ease;
      cursor: pointer;
      opacity: .7;
      &:hover{
        background-color: #ddd;
      }
      &.download{
        // right: 82px;
        background-image: url(../assets/download-o.png);
        background-size: 14px auto;
        opacity: 1;
      }
    }
    h4{
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 40px);
    }
    p{
      margin: 0;
      color: #767676;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
